import { render, staticRenderFns } from "./HeaderTownList.vue?vue&type=template&id=73a05db4&scoped=true&"
import script from "./HeaderTownList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HeaderTownList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HeaderTownList.vue?vue&type=style&index=0&id=73a05db4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a05db4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73a05db4')) {
      api.createRecord('73a05db4', component.options)
    } else {
      api.reload('73a05db4', component.options)
    }
    module.hot.accept("./HeaderTownList.vue?vue&type=template&id=73a05db4&scoped=true&", function () {
      api.rerender('73a05db4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/HeaderTownList.vue"
export default component.exports